import { render, staticRenderFns } from "./unitsRegister.vue?vue&type=template&id=2ee991a2&scoped=true&"
import script from "./unitsRegister.vue?vue&type=script&lang=js&"
export * from "./unitsRegister.vue?vue&type=script&lang=js&"
import style0 from "./unitsRegister.vue?vue&type=style&index=0&id=2ee991a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee991a2",
  null
  
)

export default component.exports